import { ITypedReduxAction } from '../../../types/redux/actionType';
import { IPostPreview } from '../../../types/postPreview';

export enum EGetPostPreviewActionType {
  Succeed = 'post/getPostPreview/succeed',
  Failed = 'post/getPostPreview/failed',
}

export type TGetPostPreviewSucceed = ITypedReduxAction<EGetPostPreviewActionType.Succeed, IPostPreview>;
export type TGetPostPreviewFailed = ITypedReduxAction<EGetPostPreviewActionType.Failed>;
export type TGetPostPreview = TGetPostPreviewSucceed | TGetPostPreviewFailed;
